<template>
	<div style="background: #f5f5f5">
		<!--banner-->
		<div class="banner">
			<div class="main_visual">
				<div class="flicking_con"> <a href="#">1</a> <a href="#">2</a> </div>
				<div class="main_image">
					<ul v-if="bannerlist.length>0">
						<li v-for="item in bannerlist" :key="item.adv_id"><a
								:href="item.adv_url?item.adv_url.url:'javascript:void(0)'"
								:target="item.adv_url?'_blank':''"><img :src="$util.img(item.adv_image)" /></a></li>
					</ul>
					<!-- <ul v-else>
                        <li><img src="@/assets/styles/images/banner.png" /></li>
                        <li><img src="@/assets/styles/images/banner1.png" /></li>
                    </ul> -->
					<a href="javascript:;" id="btn_prev"></a> <a href="javascript:;" id="btn_next"></a>
				</div>
			</div>
			<div class="xuan">
				<div>
					<!--所有产品分类-->
					<div class="menu-db">
						<b><span><img src="@/assets/styles/images/shaix.png" alt=""></span>所有产品分类</b>
						<div class="im0l">
							<ul>
								<li class="cate-0" v-for="one in categoryTree" :key="one.category_id">
									<a :href="'/goods/goodslist?category_id='+one.category_id"
										target="_blank"><span>{{one.category_name}}</span><img
											src="@/assets/styles/images/more.png" alt=""></a>
									<p>
										<template v-for="(item,i) in one.child_list">
											<a v-if="i<3" :key="item.category_id"
												:href="'/goods/goodslist?category_id='+item.category_id"
												target="_blank">{{item.category_name}}</a>
										</template>
									</p>
									<div>
										<dl v-for="two in one.child_list" :key="two.category_id">
											<dt><a :href="'/goods/goodslist?category_id='+two.category_id"
													target="_blank">{{two.category_name}}</a></dt>
											<dd>
												<a v-for="three in two.child_list" :key="three.category_id"
													:href="'/goods/goodslist?category_id='+three.category_id"
													target="_blank">{{three.category_name}}</a>
											</dd>
										</dl>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<!-- <div class="right">
                        <div class="member">
                            <div class="wel">
                                <div class="user_img" v-if="logined"><a href=""><img :src="$util.img(member.headimg)" alt=""></a></div>
                                <p>HI~欢迎来到三农网！</p>
                                <div v-if="!logined" class="btn-area"><a href="/login" class="login-btn" rel="external nofollow"><i class="icon"></i>免注册登录</a></div>
                                <div v-if="logined" class="btn-area"><a href="javascript:void(0)" class="login-btn" rel="external nofollow" @click="logout"><i class="icon"></i>退出</a></div>
                            </div>
                        </div>
                        <ul class="inter1">
                            <li>
                                <h2>{{countModel.shopCount}}</h2>
                                <img src="@/assets/styles/images/ic9.png" alt="">
                                <p>入驻企业</p>
                            </li>
                            <li>
                                <h2>{{countModel.goodsCount}}</h2>
                                <img src="@/assets/styles/images/ic10.png" alt="">
                                <p>发布产品</p>
                            </li>
                        </ul>
                        <div class="inter2">
                            <ul>
                                <li>
                                    <a href="/zhihui/ts">
                                        <img src="@/assets/styles/images/ic7.png" alt="">
                                        <p>农产品溯源</p>
                                    </a>
                                </li>
                                <li>
                                    <a href="/zhihui/iot">
                                        <img src="@/assets/styles/images/ic8.png" alt="">
                                        <p>物联网</p>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div> -->
				</div>
			</div>
		</div>

		<!--主体开始-->
		<section class="section container08" v-if="huodongshow">
			<div class="title1"> 平台活动 </div>
			<div class="neit">
				<ul v-if="huodonglist.length>0">
					<li v-for="item in huodonglist" :key="item.adv_id">
						<a :href="item.adv_url?item.adv_url.url:'javascript:void(0)'"
							:target="item.adv_url?'_blank':''">
							<img :src="$util.img(item.adv_image)" alt="">
						</a>
					</li>
				</ul>
				<!-- <ul v-else>
                <li><a href="javascript:void(0)"><img src="@/assets/images/1.png" alt=""></a></li>
                <li><a href="javascript:void(0)"><img src="@/assets/images/2.png" alt=""></a></li>
                <li><a href="javascript:void(0)"><img src="@/assets/images/3.png" alt=""></a></li>
            </ul>     -->
			</div>
		</section>
		<section class="section container00" v-if="yyggshow">
			<ul v-if="yygglist.length>0">
				<a v-for="item in yygglist" :key="item.adv_id"
					:href="item.adv_url?item.adv_url.url:'javascript:void(0)'" :target="item.adv_url?'_blank':''">
					<img :src="$util.img(item.adv_image)" alt="运营广告位">
				</a>
			</ul>
			<!-- <ul v-else>
                <a href="http://shopsn.3nong.com/shop/login/register.html" target="_blank"><img src="@/assets/styles/images/gg.png" alt="运营广告位"></a>
            </ul> -->
		</section>
		<section class="section container03">
			<div class="title">
				<div class="z">
					<h2>优质 <span>企业</span></h2>
					<p>5星级优秀企业推荐</p>
				</div>
				<a href="/shop/shoplist"><img src="@/assets/styles/images/more1.png" alt=""> </a>
			</div>
			<div class="neit">
				<ul>
					<li v-for="item in shopList" :key="item.site_id">
						<div class="sh">
							<div>
								<img src="@/assets/styles/images/ic11.png" alt="">
								<p>{{item.site_name}}</p>
							</div>
						</div>
						<a :href="'/shop-'+item.site_id" target="_blank">
							<div class="tu"> <img
									:src="item.avatar ? $util.img(item.avatar) : $util.img(defaultShopImage)" alt="">
							</div>
							<p class="b">主营：<span>{{item.goodscategory_name}}</span></p>
						</a>
					</li>
				</ul>
			</div>
		</section>

		<section class="section container02" v-for="item in floorList" :key="item">
			<div class="title1 title2">{{item.title}}</div>
			<div class="neit">
				<div class="z">
					<a :href="item.value.leftImg.value.link.url?item.value.leftImg.value.link.url:'javascript:void(0)'"
						target="_blank">
						<img :src="$util.img(item.value.leftImg.value.url)" alt="">
					</a>
				</div>
				<div class="y">
					<ul>
						<li v-for="good in item.value.goodsList.value.list" :key="good.goods_id">
							<a :href="'/sku-'+good.sku_id" target="_blank">
								<div><img :src="$util.img(good.sku_image)" alt=""></div>
								<p>{{good.goods_name}}</p>
								<div class="zi">
									<h4>{{good.price}}<span>元</span></h4>
									<p v-if="item.is_sales_open">销量：{{good.sale_num}}</p>
								</div>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</section>


		<section class="section container01">
			<div class="tj1" style="height: 440px;overflow: hidden;margin-left:0">
				<div class="title">
					<div class="z">
						<h2>最新 <span>供应</span></h2>
						<p>实时掌握最新供应</p>
					</div>
					<a href="/goods/goodslist"><img src="@/assets/styles/images/more1.png" alt=""> </a>
				</div>
				<ul>
					<li v-for="item in newgoodsList" :key="item.goods_id">
						<a :href="'/sku-'+item.sku_id" target="_blank">
							<div> <img :src="$util.img(item.image)" alt=""> </div>
							<p>{{item.goods_name}}</p>
							<h4>{{item.price}}<span>元</span></h4>
						</a>
					</li>
				</ul>
			</div>
			<div class="tj2">
				<div class="title">
					<div class="z">
						<h2>最新 <span>采购</span></h2>
						<p>实时掌握采购信息</p>
					</div>
					<a href="/purchase/list"><img src="@/assets/styles/images/more1.png" alt=""></a>
				</div>
				<div class="loop_top" style="height: 370px;overflow: hidden">
					<ul>
						<li v-for="item in purchaseList" :key="item.id">
							<a :href="'/purchase/details?id='+item.id">
								<div class="z">
									<h2>{{item.categoryname}}{{!$util.isEmpty(item.attr_value_name) ? '(' + item.attr_value_name + ')' : ''}}
									</h2>
									<p>期望货源地：{{item.areaname}}</p>
								</div>
							</a>
							<h4>{{item.number}}<span>{{item.unit}}</span></h4>
						</li>
					</ul>
				</div>
			</div>
			<div class="tj3" style="margin-right:0">
				<div class="title">
					<div class="z">
						<h2>价格 <span>行情</span></h2>
						<p>最新更新时间{{datestr}}</p>
					</div>
					<a href="/pricequotes/list"><img src="@/assets/styles/images/more1.png" alt=""> </a>
				</div>

				<ol class="head">
					<li>产品品类</li>
					<li>市场 </li>
					<li>时间 </li>
					<li>批发价 </li>
				</ol>
				<div class="loop_top" style="height: 340px;overflow: hidden">
					<ul>
						<li v-for="item in priceList" :key="item.id">
							<span>{{item.categoryname}}{{!$util.isEmpty(item.attr_value_name) ? '(' + item.attr_value_name + ')' : ''}}</span>
							<span>{{item.marketname}}</span><span>{{ $util.timeStampTurnTime(item.gathertime, 'MM-DD') }}</span><span>{{item.price}}<i>元/{{item.unit}}</i></span>
						</li>
					</ul>
				</div>
			</div>
		</section>

		<section class="section container04">
			<div class="title1"> 资讯中心 </div>
			<div class="m">
				<div class="news-qh">
					<div class="news-A1">
						<div class="sh"> <strong class="title-news">最新 <span>资讯</span></strong> <a
								href="/information/list?tid=2">更多<img src="@/assets/styles/images/more1.png" alt=""></a>
						</div>
						<div class="xia">
							<div class="news-slide" v-for="item in hyzxImg" :key="item.id">
								<div class="flexslider">
									<ul class="slides">
										<li><a :href="'/information/details?id='+item.id"><img
													:src="$util.img(item.image)" alt="" /><span
													class="">{{item.title}}</span></a></li>
									</ul>
								</div>
							</div>
						</div>
						<ul class="mdInfo-A2">
							<li class="text-overflow" v-for="item in hyzx" :key="item.id">
								<a :href="'/information/details?id='+item.id" title="">
									<p><em>[{{item.typename}}]</em>{{item.title}}</p>
									<span>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</span>
								</a>
							</li>
						</ul>
					</div>
					<div class="news-A1">
						<div class="sh"> <strong class="title-news">最新 <span>展会</span></strong> <a
								href="/information/list?tid=7">更多<img src="@/assets/styles/images/more1.png" alt=""></a>
						</div>
						<div class="xia">
							<div class="news-slide" v-for="item in zhanhuiImg" :key="item.id">
								<div class="flexslider">
									<ul class="slides">
										<li><a :href="'/information/details?id='+item.id"><img
													:src="$util.img(item.image)" alt="" /><span
													class="">{{item.title}}</span></a></li>
									</ul>
								</div>
							</div>
						</div>
						<ul class="mdInfo-A2">
							<li class="text-overflow" v-for="item in zhanhui" :key="item.id">
								<a :href="'/information/details?id='+item.id" title="">
									<p><em>[{{item.typename}}]</em>{{item.title}}</p>
									<span>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
		<section class="section container05">
			<div class="title1"> 农技中心 </div>
			<div class="m">
				<div class="news-qh">
					<div class="news-A1" style="width: 30%">
						<div class="sh"> <strong class="title-news">农技 <span>文章</span></strong> <a
								href="/information/list?tid=33">更多<img src="@/assets/styles/images/more1.png"
									alt=""></a> </div>
						<div class="xia">
							<div class="news-slide">
								<div class="flexslider">
									<ul class="slides">
										<li><a :href="'/information/details?id='+njImg.id"><img
													:src="$util.img(njImg.image)" alt="" /><span
													class="">{{njImg.title}}</span></a></li>
									</ul>
								</div>
							</div>
						</div>
						<ul class="mdInfo-A2">
							<li class="text-overflow" v-for="item in njList" :key="item.id">
								<a :href="'/information/details?id='+item.id" title="">
									<p>{{item.title}}</p>
									<span>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</span>
								</a>
							</li>
						</ul>
					</div>
					<div class="videoBox clearfix" style="width:62%">
						<div class="sh"> <strong class="title-news">农技 <span>课程</span></strong> <a
								href="/agricultural/courselist">更多<img src="@/assets/styles/images/more1.png"
									alt=""></a> </div>
						<ul class="content_new">
							<a :href="'/agricultural/coursedetails?id='+item.id" t="0" v-for="item in courseList"
								:key="item.id">
								<li class="video_item">
									<div class="c_img">
										<img :src="$util.img(item.image)" class="lazy" data-original="" alt=" " />
										<div class="overlay"> <i class="iconfont icon-shipin"></i> </div>
									</div>
									<div class="c_info">
										<h6> <span class="caption">{{item.name}}</span> </h6>
										<p>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</p>
									</div>
								</li>
							</a>
						</ul>
					</div>
				</div>
			</div>
		</section>
		<section class="section container06">
			<div class="tj1">
				<div class="title">
					<div class="z">
						<h2>农技 <span>专家</span></h2>
						<p>按分类找专家</p>
					</div>
					<a href="/agricultural/expertlist"><img src="@/assets/styles/images/more1.png" alt=""> </a>
				</div>
				<ul>
					<li v-for="item in expertList" :key="item.id">
						<div class="sh">
							<div class="z"><img :src="$util.img(item.image)" alt=""></div>
							<div class="y">
								<h2>{{item.name}}·{{item.title}} | <a
										:href="'/agricultural/expertdetails?id='+item.id">详情</a></h2>
								<p>{{item.unit}}</p>
							</div>
						</div>
						<div class="zh">
							<h2>{{item.askCount}} <span>咨询量</span></h2>
							<h2>{{item.answer_rate}}<span>回复率</span></h2>
						</div>
						<div class="xia">擅长：{{item.expert_in}}</div>
						<a :href="'/agricultural/expertdetails?id='+item.id" class="btn">免费提问</a>
					</li>
				</ul>
			</div>
		</section>
		<!-- 浮层区 -->
		<div class="floatLayer-wrap" v-if="floatLayer.is_show">
			<div class="floatLayer">
				<div class="img-wrap">
					<img :src="$img(floatLayer.img_url)" />
				</div>
				<!-- <img class="" src="@/assets/styles/images/close_red.png" alt=""> -->
				<i class="el-icon-circle-close" @click="closeFloat"></i>
			</div>
		</div>
	</div>
</template>

<style>
	::-webkit-scrollbar {
		width: 0;
	}

	.container01 .tj3 .loop_top li span:nth-child(1) {
		width: 20%;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.container01 .tj3 .loop_top li span:nth-child(2) {
		width: 35%;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.container01 .tj3 .loop_top li span:nth-child(3) {
		width: 10%;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.container01 .tj3 .loop_top li span:nth-child(4) {
		width: 26%;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.floatLayer-wrap {
		position: fixed;
		height: 100vh;
		width: 100vw;
		left: 0;
		top: 0;
		background: rgba(0, 0, 0, 0.6);
		z-index: 999;
	}

	.floatLayer-wrap .floatLayer {
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 999;
		cursor: pointer;
	}

	.floatLayer-wrap .floatLayer .img-wrap {
		width: 456px;
		height: 274px;
		line-height: 274px;
		overflow: hidden;
		text-align: center;
	}

	.floatLayer-wrap .floatLayer i {
		color: #ffffff;
		font-size: 30px;
		position: absolute;
		top: -30px;
		right: -30px;
	}

	.im0l ul {
		height: 450px;
		overflow-y: auto;
		overflow-x: hidden;
	}
</style>

<script>
	import '@/assets/styles/css/index.css';
	import '@/assets/styles/js/jquery.touchslider.js';
	import {
		indexTree
	} from '@/api/goods/goodscategory';
	import {
		purchaseList
	} from '@/api/purchase/purchase';
	import {
		pricequotesList
	} from '@/api/pricequotes/pricequotes';
	import {
		informationList
	} from '@/api/information/information';
	import {
		expertList
	} from '@/api/expert/expert';
	import {
		courseList
	} from '@/api/course/course';
	import {
		goodsList
	} from '@/api/goods/goods';
	import {
		shopAllList,
		getShopAndGoodsCount
	} from '@/api/shop';
	import {
		mapGetters
	} from "vuex";
	import {
		floors,
		floatLayer
	} from "@/api/pc";
	import {
		adList
	} from "@/api/website";

	export default {
		name: 'home',
		components: {},
		data: () => {
			return {
				loading: true,
				floorList: [],
				categoryTree: [],
				shopList: [],
				newgoodsList: [],
				goodsList: [],
				purchaseList: [],
				priceList: [],
				hyzx: [],
				hyzxImg: [],
				zhanhui: [],
				zhanhuiImg: [],
				njList: [],
				njImg: {},
				courseList: [],
				expertList: [],
				bannerlist: [],
				huodonglist: [],
				yygglist: [],
				countModel: {},
				datestr: '',
				hotcategoryList: [],
				huodongshow: false,
				yyggshow: false,
				options: {
					mainCell: "ul",
					autoPlay: true,
					effect: "topMarquee",
					vis: '6',
					interTime: 30,
				},
				floatLayer: {
					is_show: false,
					link: {
						url: ""
					}
				},
			};
		},
		created() {
			window.document.title = `首页 ${window.document.title}`
			this.getbanner();
			this.gethuodong();
			this.getyygg();
			this.getFloors();

			this.getFloatLayer();
			this.getDate();
			this.getCount();
			this.getcategoryTree();
			this.getshopList();
			this.getgoodsList('new');
			//this.getgoodsList('recommend');
			this.getpurchaseList();
			//this.getpriceList();
			this.getImgInforList('10001');
			this.getImgInforList('10002');
			this.getexpertList();
			this.getnjList();
			this.getcourseList();
			this.hotcategoryList = hottype.gettype();
		},
		computed: {
			...mapGetters(["member", "defaultShopImage"]),
			logined: function() {
				return this.member !== undefined && this.member !== "" && this.member !== {}
			}
		},
		methods: {
			getbanner() {
				adList({
					keyword: "PC_INDEX_BANNER"
				}).then(res => {
					if (res.code == 0) {
						if (res.data.adv_position.is_show == 1) {
							this.bannerlist = res.data.adv_list;
							for (let i = 0; i < this.bannerlist.length; i++) {
								if (this.bannerlist[i].adv_url) this.bannerlist[i].adv_url = JSON.parse(this
									.bannerlist[i].adv_url)
							}
						}
					}
					setTimeout(() => {
						this.inibannerclass();
					}, 500);
				}).catch(err => {
					this.inibannerclass();
				})
			},
			gethuodong() {
				adList({
					keyword: "PC_INDEX_HD"
				}).then(res => {
					if (res.code == 0) {
						this.huodongshow = res.data.adv_position.is_show == 1 ? true : false;
						this.huodonglist = res.data.adv_list.slice(0, 3);
						for (let i = 0; i < this.huodonglist.length; i++) {
							if (this.huodonglist[i].adv_url) this.huodonglist[i].adv_url = JSON.parse(this
								.huodonglist[i].adv_url)
						}
					}
				})
			},
			getFloors() {
				floors()
					.then(res => {
						this.floorList = res.data;
					})
					.catch(err => {
						console.log(err)
					})
			},
			getyygg() {
				adList({
					keyword: "PC_INDEX_YYGG"
				}).then(res => {
					if (res.code == 0) {
						this.yyggshow = res.data.adv_position.is_show == 1 ? true : false;
						this.yygglist = res.data.adv_list.slice(0, 3);
						for (let i = 0; i < this.yygglist.length; i++) {
							if (this.yygglist[i].adv_url) this.yygglist[i].adv_url = JSON.parse(this.yygglist[i]
								.adv_url)
						}
					}
				})
			},
			inibannerclass() {
				$(".main_visual").hover(function() {
					$("#btn_prev,#btn_next").fadeIn()
				}, function() {
					$("#btn_prev,#btn_next").fadeOut()
				});

				var dragBln = false;

				$(".main_image").touchSlider({
					flexible: true,
					speed: 200,
					btn_prev: $("#btn_prev"),
					btn_next: $("#btn_next"),
					paging: $(".flicking_con a"),
					counter: function(e) {
						$(".flicking_con a").removeClass("on").eq(e.current - 1).addClass("on");
					}
				});

				$(".main_image").bind("mousedown", function() {
					dragBln = false;
				});

				$(".main_image").bind("dragstart", function() {
					dragBln = true;
				});

				$(".main_image a").click(function() {
					if (dragBln) {
						return false;
					}
				});

				var timer = setInterval(function() {
					$("#btn_next").click();
				}, 5000);

				$(".main_visual").hover(function() {
					clearInterval(timer);
				}, function() {
					timer = setInterval(function() {
						$("#btn_next").click();
					}, 5000);
				});

				$(".main_image").bind("touchstart", function() {
					clearInterval(timer);
				}).bind("touchend", function() {
					timer = setInterval(function() {
						$("#btn_next").click();
					}, 5000);
				});
			},
			getDate() {
				var date = new Date();
				var month = date.getMonth() + 1;
				var day = date.getDate();
				if (month < 10) {
					month = '0' + month;
				}
				if (day < 10) {
					day = '0' + day;
				}
				this.datestr = month + '-' + day;
			},
			getcategoryTree() {
				indexTree({
					limit: ''
				}).then(res => {
					if (res.code == 0) {
						this.categoryTree = res.data;
					}
				})
			},
			getshopList() {
				shopAllList({
					limit: 5
				}).then(res => {
					if (res.code == 0) {
						this.shopList = res.data;
					}
				})
			},
			getgoodsList(type) {
				var params = {};
				if (type == 'new') {
					params = {
						order: 'goods_id desc',
						limit: 6
					}
				}
				if (type == 'recommend') {
					params = {
						limit: 8
					}
				}
				goodsList(params).then(res => {
					if (res.code == 0) {
						if (type == 'new') {
							this.newgoodsList = res.data;
						}
						if (type == 'recommend') {
							this.goodsList = res.data;
						}
					}
				})
			},
			getpurchaseList() {
				purchaseList({

				}).then(res => {
					if (res.code == 0) {
						this.purchaseList = res.data;
					}
					this.getpriceList();
				})
			},
			getpriceList() {
				pricequotesList({
					type: 2
				}).then(res => {
					if (res.code == 0) {
						this.priceList = res.data;
					}
					setTimeout(() => {
						$('.loop_top').slide({
							mainCell: "ul",
							autoPlay: true,
							effect: "topMarquee",
							vis: '6',
							interTime: 30,
						});
					}, 100);
				})
			},
			getImgInforList(typenumber) {
				informationList({
					typenumber: typenumber,
					limit: 2,
					isImg: 'true'
				}).then(res => {
					if (res.code == 0) {
						if (typenumber == "10001") {
							this.hyzxImg = res.data;
						} else {
							this.zhanhuiImg = res.data;
						}
					}
					this.getInformationList(typenumber);
				})
			},
			getInformationList(typenumber) {
				informationList({
					typenumber: typenumber,
					limit: 9,
				}).then(res => {
					if (res.code == 0) {
						if (typenumber == "10001") {
							if (this.hyzxImg.length > 0) {
								var ids = [];
								this.hyzxImg.forEach(item => {
									ids.push(item.id);
								});
								var hyzxlist = res.data.filter(function(item) {
									return ids.indexOf(item.id) < 0;
								});
								this.hyzx = hyzxlist.slice(0, 7);
							} else {
								this.hyzx = res.data.slice(0, 7);
							}

						} else {
							if (this.zhanhuiImg.length > 0) {
								var ids = [];
								this.zhanhuiImg.forEach(item => {
									ids.push(item.id);
								});
								var zhanhuilist = res.data.filter(function(item) {
									return ids.indexOf(item.id) < 0;
								});
								this.zhanhui = zhanhuilist.slice(0, 7);
							} else {
								this.zhanhui = res.data.slice(0, 7);
							}

						}
					}
					this.loading = false;
				}).catch(err => {
					this.loading = false;
					//this.$message.error(err.message);
				})
			},
			getexpertList() {
				expertList({
					limit: 3
				}).then(res => {
					if (res.code == 0) {
						this.expertList = res.data;
					}
				});
			},
			getnjList() {
				informationList({
					typenumber: "10003",
					recomment: false,
					limit: 10
				}).then(res => {
					if (res.code == 0) {
						var imglist = res.data.filter(function(item) {
							return item.image != "";
						});
						if (imglist.length > 0) {
							this.njImg = imglist[0];
							this.njList = res.data.filter(function(item) {
								return item.id != imglist[0].id;
							});
						}
					}
				});
			},
			getcourseList() {
				courseList({
					limit: 8
				}).then(res => {
					if (res.code == 0) {
						this.courseList = res.data;
					}
				});
			},
			getCount() {
				getShopAndGoodsCount({

				}).then(res => {
					if (res.code == 0) {
						this.countModel = res.data;
					}
				})
			},
			logout() {
				this.$store.dispatch("member/logout")
			},
			getFloatLayer() {
				floatLayer()
					.then(res => {
						if (res.code == 0 && res.data) {
							this.floatLayer = res.data
							this.floatLayer.link = JSON.parse(this.floatLayer.url)
							// 弹框形式，首次弹出 1，每次弹出 0

							if (!this.floatLayer.img_url) return

							if (parseInt(this.floatLayer.number) == 1) {
								var index_popwindow_count = this.$store.state.app.indexFloatLayerNum;
								if (index_popwindow_count == '' || index_popwindow_count == 1) {
									this.floatLayer.is_show = true
									this.$store.commit("app/SET_FLOAT_LAYER", 1)
								}
							} else if (parseInt(this.floatLayer.number) == 0) {
								this.floatLayer.is_show = true
								this.$store.commit("app/SET_FLOAT_LAYER", 0)
							}
						}
					})
					.catch(err => err)
			},
			closeFloat() {
				this.floatLayer.is_show = false
				this.$forceUpdate()
				this.$store.commit("app/SET_FLOAT_LAYER", -1)
			},
		},
		mounted() {

			// setTimeout(() => {
			//    //滚动表格
			//     $('.loop_top').slide({
			//         mainCell: "ul",
			//         autoPlay: true,
			//         effect: "topMarquee",
			//         vis: '6',
			//         interTime:30,
			//     }); 
			// }, 1000);

			//置顶图标显示
			$('#top-back').hide()
			$(window).scroll(function() {
				if ($(this).scrollTop() > 350) {
					$("#top-back").fadeIn();
				} else {
					$("#top-back").fadeOut();
				}
			})
			//置顶事件
			function topBack() {
				$('body,html').animate({
					scrollTop: 0
				}, 300);
			};


			$(document).ready(function($) {

				$(window).scroll(function() {
					var $scrolltop = $(this).scrollTop();
					// var top = $(body.innerHeight)
					if ($scrolltop >= "100") {
						$(".scroll").css({
							display: 'block',
						});
					} else {
						$(".scroll").css({
							display: 'none',
						});
					}
				});
			});


			$(document).ready(function() {



			});
		}

	}
</script>
